import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(saleAreaId) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
    status: 0,
  };
  const searchOptionSales = {
    limit: 10000000,
    page: 1,
  };
  let saleBlockParams = {
    limit: 10000000,
    page: 1,
  };

  if(saleAreaId){
    saleBlockParams.saleAreaId = saleAreaId;
  }
  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  const searchOptionSaleQueryParams = new URLSearchParams(searchOptionSales).toString();
  const searchSaleBlockQueryParams = new URLSearchParams(saleBlockParams).toString();
  

  // Fetch constant data concurrently
  const [employee, saleBlock, saleArea, branch] = await Promise.all([
    clientAPI("get", `/employee?${searchQueryParams}`),
    clientAPI("get", `/saleBlock?${searchSaleBlockQueryParams}`),
    clientAPI("get", `/saleArea?${searchOptionSaleQueryParams}`),
    clientAPI("get", `/branch?${searchOptionSaleQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    employee: employee?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
    saleBlock: saleBlock?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleArea: saleArea?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    branch: branch?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
  };
}

export function useCategories(shouldFetch, saleAreaId) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["registerCheckIn2",saleAreaId],
    queryFn: () => fetchConstantData(saleAreaId),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
